module.exports = __webpack_public_path__ + "./Bryan_color_4a31bf3b9a0ad3c094711b9d5a6e4d9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Bryan_color.jpg
// module id = 586
// module chunks = 0